// extracted by mini-css-extract-plugin
module.exports = {"title":"Title-module--title--Q6gIm","withBack":"Title-module--with-back--ZzsfU","large":"Title-module--large--N3yxf"};